import React from "react";
import { StyledButton } from "../../styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useMetadataTagDetails } from "../../context";

const ActionButton = () => {
  const {
    submitting,
    onSubmitMetadataTag,
    onSubmitMetadataTagTranslation
  } = useMetadataTagDetails();

  const { allowed: hasWriteAccess } = useRolePermission("tags:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission("tags:translations:write");

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <StyledButton
        title="Save"
        size="small"
        onClick={onSubmitMetadataTagTranslation}
        loading={submitting}
      />
    );
  }

  return (
    <StyledButton
      title="Save"
      size="small"
      onClick={onSubmitMetadataTag}
      loading={submitting}
    />
  );
};

export default ActionButton;